import { useMemo } from 'react'
import {
  recordClick,
  recordErrorImpression,
  recordImpression,
  logActivity,
  recordClientClick,
  recordClientEvent,
} from 'utils/fpti'

import usePageImpression from './usePageImpression'

export default function useAnalytics(data = {}, options = {}) {
  usePageImpression(data, options)

  return useMemo(() => {
    const getStub = (page) => data?.page || page
    const recordErrorAsImpression = (logImpression = true) => ({ page, ...restTags }) =>
      recordErrorImpression(
        getStub(page),
        {
          errorPage: `${getStub(page)}:error`,
          ...restTags,
        },
        !logImpression,
      )

    return {
      // recordClick is deprecated, please use recordClientClick
      recordClick: ({ page, link, ...restTags }) => recordClick(getStub(page), link, restTags),
      recordClientClick: (opts) => recordClientClick(opts),
      // logActivity is deprecated, please use recordClientEvent
      logActivity: ({ page, ...restTags }) => logActivity(getStub(page), restTags),
      recordClientEvent: ({ eventName, ...restTags }) => recordClientEvent(eventName, restTags),
      recordImpression: ({ page, ...restTags }) => recordImpression(getStub(page), restTags),
      recordErrorImpression: recordErrorAsImpression(),
      recordErrorActivity: recordErrorAsImpression(false),
    }
  }, [data?.page])
}
